// Unsorted stuff
window.translate = window.translate || {};

window.appendJsTranslations = function (translations) {
    if (typeof translations === 'object') {
        for (const [key, value] of Object.entries(translations)) {
            window.translate[key] = value;
        }
    }
}

window.getCommonError = function () {
    return window.translate.site_error_general;
}

window.reload_window = function () {
    window.location.reload();
}

window.toggleHoverMenu = function (el, forceState) {
    el = $(el);
    if(el && el.length) {
        let isOpen = !el.hasClass('open');
        if(typeof forceState === 'boolean') {
            isOpen = forceState;
        }
        if (isOpen) {
            closeAllHoverMenus(el);
            el.addClass('open');
        } else {
            el.removeClass('open');
        }
        el.attr('role','menu');
        el.attr('aria-expanded',isOpen ? 'true' : 'false');
        el.find('a').attr('role', 'menuitem');
        el.find('a').attr('aria-hidden', isOpen ? 'false' : 'true');
        el.find('a').attr('tabindex',isOpen ? '0' : '-1');
    }
}

window.closeAllHoverMenus = function(exceptionEl) {
    $('.hover-menu').each((i, el)=>{
        if($(el)[0] !== $(exceptionEl)[0]) {
            toggleHoverMenu($(el),false);
        }
    });
}

$(document).on('click', '[data-toggle="click"]', function () {
    $($(this).data('target')).trigger('click')
    return false
})

$(document).ready(function () {
    closeAllHoverMenus();
    $('.hover-menu').on('focus',function (e) {
        toggleHoverMenu($(this),true);
    });
    $('.hover-menu a').on('click blur',function (e) {
        toggleHoverMenu($(this).closest('.hover-menu'),false);
    });
    $('.hover-menu a').on('focus',function (e) {
        toggleHoverMenu($(this).closest('.hover-menu'),true);
    });
})
